var SentenceStarterTextArea = require("components/writing/questions/SentenceStarterTextArea");

class MultiPartSentenceStarter extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onChange(index, text) {
		var newParts = _.clone(this.props.answerParts);
		newParts[index] = _.extend({}, this.props.answerParts[index], {
			text: text
		});
		this.props.onChange(newParts)
	}

	render() {
		var index = 0;
		var textareas = [];

		var parts = this.props.answerParts;
		while ((index + 1) < parts.length) {
			// Assumes they're ordered starter, text, starter, text, ...
			textareas.push(
				<SentenceStarterTextArea key={ index }
					starterText={ parts[index].text }
					handlePasteBehaviour={ this.props.handlePasteBehaviour }
					onChange={ this.onChange.bind(this, (index + 1)) }
					value={ parts[index + 1].text } 
					speechControlSetting={ this.props.speechControlSetting } />
			);
			index += 2;
		}

		return (
			<div className="multiPartSentenceStarter">
				{ textareas }
			</div>
		)
	}
}

MultiPartSentenceStarter.initialAnswerParts = (starterOps, seed) => {
	var randIndex = $wr.psuedoRandom(seed, starterOps.length);
	return _.flatten(_.map(starterOps[randIndex], (starterText) => {
		return [
			{ type: STARTER, text: starterText },
			{ type: BODY, text: "" }
		];
	}));
}

var STARTER = "starter";
var BODY = "body";
var QUESTION = "question";
var ANSWER = "answer";
var SYNONYM = "synonym"

MultiPartSentenceStarter.BODY = BODY;
MultiPartSentenceStarter.STARTER = STARTER;
MultiPartSentenceStarter.ANSWER = ANSWER;
MultiPartSentenceStarter.QUESTION = QUESTION;
MultiPartSentenceStarter.SYNONYM = SYNONYM;

MultiPartSentenceStarter.propTypes = StrictPropTypes({
	answerParts: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	maxLength: PropTypes.number,
	handlePasteBehaviour: PropTypes.func,
	speechControlSetting: PropTypes.string
});

module.exports = MultiPartSentenceStarter;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/MultiPartSentenceStarter.js